var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSinparLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 11029 11073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str3{stroke:#799c37;stroke-width:7.62}.fil5{fill:#799c37}.fil3,.fil4{fill:#2b2a29;fill-rule:nonzero}.fil4{fill:#dcb720}"))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9040 6037c-244 1729-1729 3060-3526 3060-1796 0-3282-1331-3525-3060H0c253 2823 2625 5036 5514 5036s5262-2213 5515-5036H9040z",
    style: {
      fill: "#95b659"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5514 1976c1797 0 3282 1331 3526 3060h1989C10776 2213 8403 0 5514 0S253 2213 0 5036h1989c243-1729 1729-3060 3525-3060z",
    style: {
      fill: "#f1d669"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2b2a29",
      strokeWidth: 139.99
    },
    d: "M3688 5537h3652"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M4247 5105c321 0 530-175 530-409 0-233-163-328-349-404l-251-101c-120-51-286-118-286-294 0-166 148-272 367-272 165 0 295 62 393 154l65-69c-100-99-260-182-458-182-276 0-482 154-482 374 0 226 193 321 336 379l251 104c163 67 296 127 296 318 0 181-158 305-412 305-190 0-363-81-484-205l-75 74c131 134 319 228 559 228zm1129-27h116V3555h-116v1523z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M4247 5093c156 0 284-42 374-111 91-71 143-171 143-286 0-112-39-192-101-252-62-61-148-103-240-140-85-35-172-69-256-104-123-52-288-122-288-303 0-87 38-158 105-208 66-49 161-77 274-77 80 0 153 15 217 40 67 26 125 64 176 110l48-52c-51-48-118-92-196-124-72-28-155-46-245-46-136 0-255 38-339 103-82 64-131 154-131 259 0 109 47 186 111 243 64 58 147 96 218 124l251 104c82 34 157 66 212 115 56 50 91 115 91 215 0 95-42 176-118 232-73 54-177 86-306 86-94 0-185-20-267-55s-156-85-217-146l-57 57c66 65 146 120 239 159 89 36 190 57 302 57zm389-91c-94 72-228 116-389 116-116 0-220-22-311-59-101-42-187-102-257-174l-8-9 93-91 8 9c61 63 135 114 218 149 79 34 166 53 257 53 123 0 223-30 291-81 70-51 108-125 108-212 0-91-31-151-82-196-52-46-125-78-206-111l-251-104c-72-29-157-68-225-128-68-62-119-145-119-262 0-113 53-210 141-278 88-69 212-109 354-109 93 0 179 18 254 48 86 35 159 84 213 138l9 9-82 87-9-9c-50-47-109-86-177-113-62-24-131-38-208-38-108 0-197 26-259 72-60 45-95 110-95 188 0 165 156 231 272 280l257 104c94 38 182 82 248 145 66 65 108 150 108 270 0 123-55 230-153 306zm753 63h90V3568h-90v1497zm103 25h-128V3543h140v1547h-12z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M3688 7546h114v-654h308c364 0 582-146 582-444 0-314-223-425-592-425h-412v1523zm114-744v-689h270c338 0 504 79 504 335 0 250-161 354-494 354h-280zm1349-153c67-180 124-339 181-526h10c57 187 114 346 181 526l104 284h-580l104-284zm-446 897h114l193-522h647l191 522h119l-575-1523h-114l-575 1523zm1599 0h114v-700h347l444 700h131l-451-707c258-30 441-171 441-414 0-291-233-402-557-402h-469v1523zm114-788v-645h325c287 0 472 84 472 312 0 224-185 333-472 333h-325z",
    style: {
      stroke: "#2b2a29",
      strokeWidth: 25
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m6355 3728 865 1350h120V3555h-110v934c0 147 10 295 15 443h-10l-880-1373v169z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "m6358 3733 869 1332h101V3568h-86v921c0 99 5 197 9 294 3 50 5 99 6 149l1 13h-30l-873-1363 3 151zm-3-191 877 1362c-2-40-4-80-6-119-4-99-9-199-9-296v-946h136v1547h-140l-858-1314v-234z",
    style: {
      stroke: "#dcb720",
      strokeWidth: 7.62
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil5 str3",
    transform: "matrix(0 -1 .78601 0 5763.57 3665.69)",
    d: "M0 0h123v1332H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil5 str3",
    d: "M6219 3666h135v1424h-135z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinparLogo);
export default __webpack_public_path__ + "static/media/sinpar-logo.fc4361ee23bb62045fef5634876445a4.svg";
export { ForwardRef as ReactComponent };